// extracted by mini-css-extract-plugin
var _1 = "Content-modulecontainer__HdwZF";
var _2 = "Content-modulecontent__lhnnP";
var _3 = "Content-modulecontentWrapper__p1AMw";
var _4 = "Content-modulefullScreen__li4vr";
var _5 = "Content-modulelContainerSize__VzXsZ";
var _6 = "Content-modulemContainerSize__alsh8";
var _7 = "Content-modulesContainerSize__ekrMg";
var _8 = "Content-modulexlContainerSize__CZD8v";
export { _1 as "container", _2 as "content", _3 as "contentWrapper", _4 as "fullScreen", _5 as "lContainerSize", _6 as "mContainerSize", _7 as "sContainerSize", _8 as "xlContainerSize" }
